// Chaves
const TESTE = '';
//const TESTE = 'teste/';

export const USERS = TESTE + "Users/";
export const CIDADES = TESTE + 'Cidades';
export const AREAS_DE_ATUACAO = TESTE + "AreasDeAtuacao";
export const ALERTA_POR_ID = TESTE + "AlertasPorUid";

export const SOLICITANTES = TESTE + 'Solicitantes';
export const CHAMADOS_POR_SOLICITANTE_EM_ABERTO = TESTE + 'ChamadosPorSolicitanteEmAberto';
export const CHAMADOS_POR_SOLICITANTE_EM_ANDAMENTO = TESTE + 'ChamadosPorSolicitanteEmAndamento'; 
export const CHAMADOS_FINALIZADOS_POR_SOLICITANTE = TESTE + 'ChamadosFinalizadosPorSolicitante'; 
export const CHAMADOS_POR_SOLICITANTE_EM_ANALISE = TESTE + 'ChamadosPorSolicitanteEmAnalise';

export const PROFISSIONAIS = TESTE + 'Profissionais';
export const CHAMADOS_POR_PROFISSIONAL_EM_ANALISE = TESTE + 'ChamadosPorProfissionalEmAnalise';
export const CHAMADOS_POR_PROFISSIONAL_EM_ANDAMENTO = TESTE + 'ChamadosPorProfissionalEmAndamento';
export const CHAMADOS_FINALIZADOS_POR_PROFISSIONAL = TESTE + 'ChamadosFinalizadosPorProfissional';
export const PROFISSIONAIS_CIDADES_ATUACAO = TESTE + 'ProfissionaisPorCidadePorAreaAtuacao';

